<script>
  import { style, blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link } from "svelte-routing";

  export let block;
</script>

<!-- Section with icon, title and description -->
<section style="{style(block)}">
  <div class="container">
    <div class="row justify-content-center">
      {#each blocklist(block, 'features') as item}
      <div class="col-lg-3 col-sm-6">
        <div class="p-3 text-center">
          <div class="icon icon-shape icon-md mx-auto">
            <img src="{image(item, 'icon', [50, 50])}" alt="Icon">
          </div>
          <h5 class="mt-4">{text(item, 'headline')}</h5>
          <p>{@html richtext(item, 'body')}</p>
        </div>
      </div>
      {/each}
    </div>
  </div>
</section>
<!-- END Section with icon, title and description -->

